import { IJob } from '@medely/types';
import { ShiftRequest, ShiftRequestKinds, ShiftRequestStatus } from '@mp/graphql/generated/graphql';

export const useRateRequest = (job: IJob) => {
  // @ts-ignore - until we add codegen to job query
  const rateChangeRequests: ShiftRequest[] | undefined = job?.professional_shift_requests?.filter(
    (r: ShiftRequest) => r.request_kind === ShiftRequestKinds.RateChange,
  );

  const mostRecentRateRequest: ShiftRequest | undefined = rateChangeRequests
    ?.sort(
      (a: ShiftRequest, b: ShiftRequest) =>
        new Date(b.submitted_at).getTime() - new Date(a.submitted_at).getTime(),
    )
    ?.shift();

  const isMostRecentRateRequestApproved =
    mostRecentRateRequest?.status === ShiftRequestStatus.Approved;

  const hasPendingRequest = mostRecentRateRequest?.status === ShiftRequestStatus.Pending;
  const hasApprovedRequest = isMostRecentRateRequestApproved;
  const hasReachedMaxRequests = (rateChangeRequests?.length ?? 0) >= 2;

  const shouldDisplayAdditionalRateOptionsButton =
    !hasPendingRequest && !hasApprovedRequest && !hasReachedMaxRequests;

  return {
    listRateChangeRequests: rateChangeRequests,
    mostRecentRateRequest,
    shouldDisplayAdditionalRateOptionsButton,
    isMostRecentRateRequestApproved,
  };
};
